export default "__VITE_ASSET__Blq_ge3P__"